<template>
  <section class="client">
    <h1>{{title}}</h1>
    <div class="row client_container">
        <div class="col-xs-6 col-lg-3 client_item">
            <div class="box">
              <figure><img src="@/assets/clients/aurick.png" alt=""></figure>
            </div>
        </div>
        <div class="col-xs-6 col-lg-3 client_item">
            <div class="box">
              <figure><img src="@/assets/clients/bitmap.png" alt=""></figure>
            </div>
        </div>
        <div class="col-xs-6 col-lg-3 client_item">
            <div class="box">
              <figure><img src="@/assets/clients/fingerpay.png" alt=""></figure>
            </div>
        </div>
        <div class="col-xs-6 col-lg-3 client_item">
            <div class="box">
              <figure><img src="@/assets/clients/mythya.png" alt=""></figure>
            </div>
        </div>
        <div class="col-xs-6 col-lg-3 client_item">
            <div class="box">
              <figure><img src="@/assets/clients/pandacare.png" alt=""></figure>
            </div>
        </div>
        <div class="col-xs-6 col-lg-3 client_item">
            <div class="box">
              <figure><img src="@/assets/clients/puzzlesmadia.png" alt=""></figure>
            </div>
        </div>
        <div class="col-xs-6 col-lg-3 client_item">
            <div class="box">
              <figure><img src="@/assets/clients/querya.png" alt=""></figure>
            </div>
        </div>
        <div class="col-xs-6 col-lg-3 client_item">
            <div class="box">
              <figure><img src="@/assets/clients/zamooza.png" alt=""></figure>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'client',
  props: {
    title: String
  }
}
</script>

<style scoped lang="scss">
  .client{
    .client_container{
      margin: 0 -0.12rem;
    }
    .client_item{
      padding:0.12rem;
      transition: all 0.1s;
      &:hover{
        position: relative;
        z-index: 1;
        box-shadow: 0 2px 124px 0 rgba(0, 0, 0, 0.5);
      }
    }
    figure{
      margin: 0;
      height: 100%;
      background: $white;
      display: flex;
      align-content: center;
      justify-content:center;
      img{
        align-self: center;
        max-width: 70%;
      }
    }
    figure:before {
        content:'';
        padding-top:100%;
    }
  }
</style>
